
import { Observable } from 'rxjs';
import { User } from 'app/core/api/types';

export abstract class AuthStrategy {
    abstract initialize(): Observable<{ loggedIn: boolean }>;
    abstract login(email: string, password: string): Observable<{ accessToken: string; refreshToken?: string }>;
    abstract getCurrentUser(): Observable<User | null>;
    abstract logout(): Observable<void>;

    refresh?(): Observable<{ accessToken: string; refreshToken?: string }>;
    resetPassword?(email: string): Observable<void>;
    deleteUser?(userId: string): Observable<void>;
    saveUser?(user: User): Observable<User>;
    saveProfilePicture?(file: File): Observable<User>;
}
